import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// La sesión viaja en una cookie httpOnly puesta por el backend: no se guarda ningún token aquí.
export const userApi = axios.create({ baseURL: API, withCredentials: true });

userApi.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response && err.response.status === 401) {
      // solo expulsamos si estamos dentro del área de usuario
      const userPaths = ["/panel", "/comunidad", "/muro", "/mercado", "/perfil", "/amigos", "/clonador"];
      const path = window.location.pathname;
      if (userPaths.some((p) => path.startsWith(p))) window.location.href = "/acceso";
    }
    return Promise.reject(err);
  }
);

export const apiError = (e, fallback = "Algo salió mal. Inténtalo otra vez.") => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  if (d?.msg) return d.msg;
  return e?.message || fallback;
};
